 import "./aboutus.css";
import AboutusImg from "./publicImages/asdfdf.png"; 
import {
  Inventory2Outlined,
  CloudOutlined,
  QrCodeScannerOutlined,
  PointOfSaleOutlined,
  AutoGraphOutlined,
  NotificationsActiveOutlined,
  SyncOutlined,
  SecurityOutlined,
  SpeedOutlined,
  StorefrontOutlined,
  InsightsOutlined,
  GroupsOutlined,
  ArrowForward,
  CheckCircleOutlined,
  HubOutlined,
  DevicesOutlined,
  AccountBalanceWalletOutlined,
} from "@mui/icons-material";
 

const AboutUs = () => {
  return (
    <section className="aboutUsPage">

      {/* ================================================================
          HERO
      ================================================================ */}

      <div className="aboutUsHero">

        <div className="aboutUsHeroGlow aboutUsHeroGlowOne"></div>
        <div className="aboutUsHeroGlow aboutUsHeroGlowTwo"></div>

        <div className="aboutUsContainer">

          <div className="aboutUsHeroContent">

            <div className="aboutUsEyebrow">
              <span className="aboutUsEyebrowIcon">
                <HubOutlined />
              </span>

              <span>
                The Universe Inventory Ecosystem
              </span>
            </div>

            <h1>
              One Universe.
              <span> Every Part of Your Business.</span>
            </h1>

            <p className="aboutUsHeroDescription">
              Universe Inventory is a modern inventory management ecosystem
              designed to help businesses take control of their products,
              sales, purchases, operations, and business data from one
              connected platform.
            </p>

            <p className="aboutUsHeroDescriptionSecondary">
              From the warehouse to the point of sale, from barcode scanning
              to real-time notifications, Universe brings the tools your
              business needs into one intelligent environment.
            </p>

            <div className="aboutUsHeroActions">

              <button className="aboutUsPrimaryButton">
                Explore Universe Inventory
                <ArrowForward />
              </button>

              <button className="aboutUsSecondaryButton">
                Discover Our Ecosystem
              </button>

            </div>

          </div>


          {/* ============================================================
              HERO VISUAL
          ============================================================ */}

          <div className="aboutUsHeroVisual">

            <div className="aboutUsDashboardGlow"></div>

            <div className="aboutUsDashboardCard">

              <div className="aboutUsDashboardHeader">

                <div className="aboutUsDashboardBrand">
                  <div className="aboutUsDashboardLogo">
                    <Inventory2Outlined />
                  </div>

                  <div>
                    <strong>Universe Inventory</strong>
                    <span>Business Control Center</span>
                  </div>
                </div>

                <div className="aboutUsLiveIndicator">
                  <span></span>
                  Live
                </div>

              </div>


              <div className="aboutUsDashboardStats">

                <div className="aboutUsDashboardStat">
                  <span>Total Inventory</span>
                  <strong>12,840</strong>
                  <small>
                    <AutoGraphOutlined />
                    Inventory tracked
                  </small>
                </div>

                <div className="aboutUsDashboardStat">
                  <span>Today's Sales</span>
                  <strong>₦842,500</strong>
                  <small>
                    <AutoGraphOutlined />
                    Business activity
                  </small>
                </div>

              </div>


              <div className="aboutUsDashboardActivity">

                <div className="aboutUsActivityHeader">
                  <span>Live Activity</span>

                  <span className="aboutUsActivityStatus">
                    <span></span>
                    Connected
                  </span>
                </div>


                <div className="aboutUsActivityItem">

                  <div className="aboutUsActivityIcon inventory">
                    <Inventory2Outlined />
                  </div>

                  <div>
                    <strong>Inventory updated</strong>
                    <span>Product quantity synchronized</span>
                  </div>

                  <small>Now</small>

                </div>


                <div className="aboutUsActivityItem">

                  <div className="aboutUsActivityIcon sale">
                    <PointOfSaleOutlined />
                  </div>

                  <div>
                    <strong>New transaction</strong>
                    <span>POS transaction received</span>
                  </div>

                  <small>2m</small>

                </div>


                <div className="aboutUsActivityItem">

                  <div className="aboutUsActivityIcon cloud">
                    <CloudOutlined />
                  </div>

                  <div>
                    <strong>Cloud synchronization</strong>
                    <span>Business data synchronized</span>
                  </div>

                  <small>4m</small>

                </div>

              </div>

            </div>


            <div className="aboutUsFloatingCard aboutUsFloatingCardOne">

              <div className="aboutUsFloatingIcon">
                <SyncOutlined />
              </div>

              <div>
                <strong>Real-time Sync</strong>
                <span>Everything connected</span>
              </div>

            </div>


            <div className="aboutUsFloatingCard aboutUsFloatingCardTwo">

              <div className="aboutUsFloatingIcon">
                <SecurityOutlined />
              </div>

              <div>
                <strong>Secure Business Data</strong>
                <span>Built for business</span>
              </div>

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          INTRODUCTION
      ================================================================ */}

      <div className="aboutUsIntro">

        <div className="aboutUsContainer">

          <div className="aboutUsSectionHeading">

            <div className="aboutUsSectionLabel">
              <span></span>
              ABOUT UNIVERSE
            </div>

            <h2>
              Built to make business
              <span> easier to understand.</span>
            </h2>

            <p>
              Running a business means dealing with thousands of small
              decisions every day. Products move. Customers buy. Stock
              changes. Payments arrive. Purchases are made. Employees
              perform transactions. Business owners need to know what is
              happening.
            </p>

            <p>
              Universe Inventory was built to bring all of these moving
              parts together into one connected system, giving businesses
              better visibility, better control, and better tools to make
              informed decisions.
            </p>

          </div>


          <div className="aboutUsIntroCards">

            <div className="aboutUsIntroCard">
              <div className="aboutUsIntroCardIcon">
                <InsightsOutlined />
              </div>

              <h3>See Your Business</h3>

              <p>
                Understand inventory, sales, purchases, transactions and
                business activity from one centralized environment.
              </p>
            </div>


            <div className="aboutUsIntroCard">
              <div className="aboutUsIntroCardIcon">
                <SpeedOutlined />
              </div>

              <h3>Move Faster</h3>

              <p>
                Reduce manual processes and give your team tools designed
                for fast and efficient everyday operations.
              </p>
            </div>


            <div className="aboutUsIntroCard">
              <div className="aboutUsIntroCardIcon">
                <SecurityOutlined />
              </div>

              <h3>Stay in Control</h3>

              <p>
                Keep your business operations organized while maintaining
                visibility over the activities that matter.
              </p>
            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          ECOSYSTEM
      ================================================================ */}

      <div className="aboutUsEcosystem">

        <div className="aboutUsContainer">

          <div className="aboutUsSectionHeading centered">

            <div className="aboutUsSectionLabel">
              <span></span>
              ONE CONNECTED ECOSYSTEM
            </div>

            <h2>
              More than inventory.
              <span> An entire business ecosystem.</span>
            </h2>

            <p>
              Universe is designed as a collection of connected tools,
              each solving a different part of the business while working
              together as one ecosystem.
            </p>

          </div>


          <div className="aboutUsProducts">


            {/* INVENTORY */}

            <div className="aboutUsProductCard aboutUsProductMain">

              <div className="aboutUsProductTop">

                <div className="aboutUsProductIcon">
                  <Inventory2Outlined />
                </div>

                <span className="aboutUsProductNumber">
                  01
                </span>

              </div>

              <h3>Universe Inventory</h3>

              <p>
                The central platform for managing products, inventory,
                purchases, sales, returns, deliveries, transfers,
                adjustments, production, expenses, discounts and other
                essential business operations.
              </p>

              <div className="aboutUsProductFeatures">

                <span>
                  <CheckCircleOutlined />
                  Inventory Management
                </span>

                <span>
                  <CheckCircleOutlined />
                  Product Management
                </span>

                <span>
                  <CheckCircleOutlined />
                  Sales & Purchases
                </span>

                <span>
                  <CheckCircleOutlined />
                  Business Reports
                </span>

              </div>

            </div>


            {/* UNI CLOUD */}

            <div className="aboutUsProductCard">

              <div className="aboutUsProductTop">

                <div className="aboutUsProductIcon cloudIcon">
                  <CloudOutlined />
                </div>

                <span className="aboutUsProductNumber">
                  02
                </span>

              </div>

              <h3>Uni-Cloud</h3>

              <p>
                Uni-Cloud keeps business activity connected through
                real-time notifications, helping users stay informed about
                transactions and important events even when they are away
                from the main system.
              </p>

              <div className="aboutUsProductHighlight">
                <NotificationsActiveOutlined />
                <span>
                  Real-time business notifications
                </span>
              </div>

            </div>


            {/* CAM SCANNER */}

            <div className="aboutUsProductCard">

              <div className="aboutUsProductTop">

                <div className="aboutUsProductIcon scannerIcon">
                  <QrCodeScannerOutlined />
                </div>

                <span className="aboutUsProductNumber">
                  03
                </span>

              </div>

              <h3>Cam-Scanner</h3>

              <p>
                Cam-Scanner turns your computer camera into a practical
                barcode scanning tool, allowing businesses to scan products
                quickly without requiring a dedicated barcode scanner.
              </p>

              <div className="aboutUsProductHighlight">
                <QrCodeScannerOutlined />
                <span>
                  Fast camera-based barcode scanning
                </span>
              </div>

            </div>


            {/* POS */}

            <div className="aboutUsProductCard">

              <div className="aboutUsProductTop">

                <div className="aboutUsProductIcon posIcon">
                  <PointOfSaleOutlined />
                </div>

                <span className="aboutUsProductNumber">
                  04
                </span>

              </div>

              <h3>Universe Point of Sale</h3>

              <p>
                Universe Point of Sale provides businesses with a
                dedicated environment for processing sales, accepting
                payments and managing point-of-sale transactions while
                remaining connected to the wider inventory ecosystem.
              </p>

              <div className="aboutUsProductHighlight">
                <StorefrontOutlined />
                <span>
                  Connected point-of-sale operations
                </span>
              </div>

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          HOW EVERYTHING CONNECTS
      ================================================================ */}

      <div className="aboutUsConnection">

        <div className="aboutUsContainer">

          <div className="aboutUsConnectionVisual">

            <div className="aboutUsConnectionNode nodeInventory">
              <Inventory2Outlined />
              <span>Inventory</span>
            </div>

            <div className="aboutUsConnectionLine lineOne"></div>

            <div className="aboutUsConnectionNode nodeCloud">
              <CloudOutlined />
              <span>Uni-Cloud</span>
            </div>

            <div className="aboutUsConnectionLine lineTwo"></div>

            <div className="aboutUsConnectionNode nodeScanner">
              <QrCodeScannerOutlined />
              <span>Cam-Scanner</span>
            </div>

            <div className="aboutUsConnectionLine lineThree"></div>

            <div className="aboutUsConnectionNode nodePOS">
              <PointOfSaleOutlined />
              <span>Point of Sale</span>
            </div>

            <div className="aboutUsConnectionCenter">
              <HubOutlined />
              <span>Universe</span>
            </div>

          </div>


          <div className="aboutUsConnectionContent">

            <div className="aboutUsSectionLabel">
              <span></span>
              CONNECTED BY DESIGN
            </div>

            <h2>
              Every tool works better
              <span> when they work together.</span>
            </h2>

            <p>
              Universe is not built as a collection of disconnected
              applications. The ecosystem is designed around a shared
              business environment where information can move between the
              tools your business uses.
            </p>

            <p>
              A sale at the point of sale can affect inventory. A barcode
              scan can help identify a product. Business activity can
              generate real-time notifications. The result is a more
              connected view of what is happening across the business.
            </p>

            <button className="aboutUsTextButton">
              Explore the Universe ecosystem
              <ArrowForward />
            </button>

          </div>

        </div>

      </div>


      {/* ================================================================
          FEATURES
      ================================================================ */}

      <div className="aboutUsCapabilities">

        <div className="aboutUsContainer">

          <div className="aboutUsSectionHeading centered">

            <div className="aboutUsSectionLabel">
              <span></span>
              BUILT FOR REAL BUSINESS
            </div>

            <h2>
              Designed around
              <span> how businesses actually operate.</span>
            </h2>

          </div>


          <div className="aboutUsCapabilitiesGrid">

            <div className="aboutUsCapability">
              <div>
                <Inventory2Outlined />
              </div>
              <h3>Inventory Visibility</h3>
              <p>
                Know what products you have, where they are and how your
                inventory is changing.
              </p>
            </div>


            <div className="aboutUsCapability">
              <div>
                <PointOfSaleOutlined />
              </div>
              <h3>Connected Sales</h3>
              <p>
                Process sales while keeping your business operations
                connected to inventory.
              </p>
            </div>


            <div className="aboutUsCapability">
              <div>
                <QrCodeScannerOutlined />
              </div>
              <h3>Barcode Operations</h3>
              <p>
                Make product identification faster using camera-based
                barcode scanning.
              </p>
            </div>


            <div className="aboutUsCapability">
              <div>
                <NotificationsActiveOutlined />
              </div>
              <h3>Real-Time Awareness</h3>
              <p>
                Stay informed about important business activity through
                connected notifications.
              </p>
            </div>


            <div className="aboutUsCapability">
              <div>
                <AutoGraphOutlined />
              </div>
              <h3>Business Intelligence</h3>
              <p>
                Turn everyday business activity into information that can
                help you understand your operations.
              </p>
            </div>


            <div className="aboutUsCapability">
              <div>
                <DevicesOutlined />
              </div>
              <h3>Connected Devices</h3>
              <p>
                Extend your business workflow across the devices your team
                already uses.
              </p>
            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          VISION
      ================================================================ */}

      <div className="aboutUsVision">

        <div className="aboutUsContainer">

          <div className="aboutUsVisionCard">

            <div className="aboutUsVisionGlow"></div>

            <div className="aboutUsVisionIcon">
              <AutoGraphOutlined />
            </div>

            <div className="aboutUsVisionContent">

              <div className="aboutUsSectionLabel">
                <span></span>
                OUR VISION
              </div>

              <h2>
                Give every business
                <span> better control of its universe.</span>
              </h2>

              <p>
                We believe business software should not make business more
                complicated. It should make the complexity easier to
                understand.
              </p>

              <p>
                Our vision is to create a connected business ecosystem
                where businesses can manage their operations with
                confidence, respond to activity in real time and make
                better decisions using the information already generated
                by their daily operations.
              </p>

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          VALUES
      ================================================================ */}

      <div className="aboutUsValues">

        <div className="aboutUsContainer">

          <div className="aboutUsSectionHeading">

            <div className="aboutUsSectionLabel">
              <span></span>
              WHAT DRIVES US
            </div>

            <h2>
              Simple principles.
              <span> Serious software.</span>
            </h2>

          </div>


          <div className="aboutUsValuesGrid">

            <div className="aboutUsValue">
              <span>01</span>
              <GroupsOutlined />
              <h3>Business First</h3>
              <p>
                Every feature should solve a real business problem and
                create practical value.
              </p>
            </div>


            <div className="aboutUsValue">
              <span>02</span>
              <SpeedOutlined />
              <h3>Efficiency</h3>
              <p>
                Business software should remove unnecessary work rather
                than create more of it.
              </p>
            </div>


            <div className="aboutUsValue">
              <span>03</span>
              <SecurityOutlined />
              <h3>Trust</h3>
              <p>
                Businesses depend on their data, so reliability,
                security and transparency matter.
              </p>
            </div>


            <div className="aboutUsValue">
              <span>04</span>
              <HubOutlined />
              <h3>Connected Thinking</h3>
              <p>
                The best business experience comes from tools that work
                together instead of operating in isolation.
              </p>
            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          FINAL CTA
      ================================================================ */}

      <div className="aboutUsCTA">

        <div className="aboutUsCTAOrb aboutUsCTAOrbOne"></div>
        <div className="aboutUsCTAOrb aboutUsCTAOrbTwo"></div>

        <div className="aboutUsContainer">

          <div className="aboutUsCTAContent">

            <div className="aboutUsCTAIcon">
              <AccountBalanceWalletOutlined />
            </div>

            <h2>
              Your business has a universe.
              <span> We help you manage it.</span>
            </h2>

            <p>
              Bring inventory, sales, payments, scanning, notifications and
              business operations into one connected ecosystem.
            </p>

            <button className="aboutUsPrimaryButton">
              Get Started With Universe
              <ArrowForward />
            </button>

          </div>

        </div>

      </div>

    </section>
  );
};
 

export default AboutUs; 
